
const toZhwydjpt = r => require.ensure([], () => r(require('@/page/toZhwydjpt/toZhwydjpt.vue')), 'toZhwydjpt');

const toZhwyDjRouter = {
  path: '',
  redirect: '/toZhwydjpt',
  name: '智慧物业对接平台',
  component: toZhwydjpt,
  meta: {
    icon: 'vote',
    right: [],
    isShowMenu: true,
  },
  children: [
    { path: '/toZhwydjpt',component: toZhwydjpt, name: '智慧物业对接平台', meta: { right: [], isShowMenu: true, keepAlive: true }, },
  ]
};
export default toZhwyDjRouter;
